import { defineStore } from 'pinia';
import axios from 'axios';
import { isConditionalRebateEnabled } from '../../../../js/services/CommonUtility';
import { isFordDealer } from '../../Events/FordDirect/FordCookieService';

export const useIncentiveStore = defineStore('incentiveStore', {
  state: () => ({
    fordDirectQualifiedIncentives: [],
    conditionalRebateIncentives: [],
    isConditionalRebateIncentiveEnabled: isConditionalRebateEnabled(window.vehicleType),
    fordIncentiveSource: isFordDealer(window.IncentiveSource),
    paymentSettings: {},
    paymentCollectionData: [],
    msrpDetailsData: [],
    qualifiedIncentiviesData: [],
    vehicleInfoData: {},
  }),

  actions: {
    setFordDirectQualifiedIncentives(payload) {
      this.fordDirectQualifiedIncentives = payload;
    },

    setConditionalRebateIncentives(payload) {
      this.conditionalRebateIncentives = payload;
    },
    setPaymentSettings(payload) {
      this.paymentSettings = payload;
    },

    async getConditionalRebates(paramsData) {
      const { vin, styleId, accountId, make, model, year, type, zipcode } = paramsData;
      console.log(zipcode, 'zipcode');
      let url = '';
      let actionType = '';

      const showRebates = window.showRebatesDetails || window.showRebatesBreakoutVDP || true;
      const showConditionalRebates = window.showConditionalRebates || true;

      if (this.fordIncentiveSource) {
        url = `${atob(
          window.portalUrl
        )}offermanager/Service/oem/GetAllFordDirectQualifiedIncentives?AccountId=${accountId}&vin=${vin}&StyleId=${styleId}&make=${make}&model=${model}&year=${year}&type=${type}`;
        actionType = 'fordDirect';
      } else if (this.isConditionalRebateIncentiveEnabled) {
        url = `${window.ApiBaseUrl}/Inventory/GetQualifiedAndRebateDetails?vin=${vin}&accountId=${accountId}&zipcode=${zipcode}&incentiveSource=${window.IncentiveSource}&incentiveType=All&styleId=${styleId}&make=${make}&model=${model}&year=${year}&type=${type}&conditional=${showConditionalRebates}&rebates=${showRebates}`;
        actionType = 'conditional';
      } else {
        return; // No action needed
      }

      try {
        const response = await axios.get(url);
        const data = response.data;

        if (!data) return;

        if (actionType === 'fordDirect') {
          if (data.length > 0) {
            this.setFordDirectQualifiedIncentives(data[0].Qualified);
          }
        } else if (actionType === 'conditional') {
          if (Array.isArray(data) && data.length > 0) {
            const matched = data.find((item) => item.vin?.toLowerCase() === vin);
            if (matched) {
              this.setConditionalRebateIncentives(matched.qualified);
            }
          }
        }
      } catch (err) {
        console.error('Error fetching incentives:', err);
      }
    },
    async getPaymentSettings(paramsData) {
      let { vin, styleId, accountId, make, model, year, type, zipcode } = paramsData;

      if (vin) {
        styleId = '';
      }

      let response = '';
      try {
        response = await axios.get(
          `${window.ApiBaseUrl}/Inventory/getPaymentSettingDetails?accountId=${accountId}&vin=${vin}&styleid=${styleId}`
        );
        console.log(response, 'response');
        this.setPaymentSettings(response.data);
        state.paymentSettings = response.data;
      } catch {
        console.log('error');
      }
    },
  },
});
